import IconAI2 from '@bimser/icons/16/ai2';
import Markdown from 'react-markdown';
import Styles from '../assets/styles.scss';
import rehypeHighlight from 'rehype-highlight';
import { IAssistantMessageProps } from '../entities/IAssistantMessageProps';
import { AssistantMessageFeedback } from './AssistantMessageFeedback';
import classNames from 'classnames/bind';
import { MarkdownCode } from './markdown/MarkdownCode';
import { MarkdownCodeCopy } from './markdown/MarkdownCodePre';
import React from 'react';

const cx = classNames.bind(Styles);

const AssistantMessage: React.FC<IAssistantMessageProps> = props => {
	const classNames = cx({
		streaming: props.message.streaming,
		content: true
	});

	const rehypePlugins = React.useMemo(() => [rehypeHighlight], []);

	return (
		<div className={`${Styles.message} ${Styles.assistant}`}>
			<div className={Styles.row}>
				<div className={Styles.profile}>
					<IconAI2
						width="32px"
						height="32px"
					/>
				</div>
				<div className={classNames}>
					<Markdown
						rehypePlugins={rehypePlugins}
						components={{
							pre: MarkdownCodeCopy,
							code: MarkdownCode
						}}
					>
						{props.message.content}
					</Markdown>
				</div>
			</div>
			<AssistantMessageFeedback
				onResponseSent={props.onResponseSent}
				message={props.message}
				scrollToBottom={props.scrollToBottom}
				isLastMessage={props.isLastMessage}
			/>
		</div>
	);
};

export { AssistantMessage };
